import { render } from "./rank-category.vue?vue&type=template&id=261e19a0&scoped=true"
import script from "./rank-category.vue?vue&type=script&lang=js"
export * from "./rank-category.vue?vue&type=script&lang=js"

import "./rank-category.vue?vue&type=style&index=0&id=261e19a0&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-261e19a0"]])

export default __exports__